import React, { useState } from 'react';
import classNames from 'classnames/bind';
import styles from './FormFilterPrice.module.scss';
import { Row, Form, InputNumber } from 'antd';
import { checkKeyDownNumberInput } from '~/utils';

const cx = classNames.bind(styles);

const FormFilterPrice = ({ ...props }) => {
    const [form] = Form.useForm();

    const initialValues = {
        priceLow: props?.rangePrice?.priceLow,
        priceHigh: props?.rangePrice?.priceHigh,
    };
    const [isErr, setIsErr] = useState(false);

    const handleSelectPrice = (low, high) => {
        form.setFieldsValue({
            priceLow: low,
            priceHigh: high,
        });
    };

    const handleSubmit = () => {
        props?.setRangePrice({
            priceLow: Number(form.getFieldValue('priceLow')),
            priceHigh: Number(form.getFieldValue('priceHigh')),
        });
        props?.isCancel();
    };

    return (
        <Form form={form} initialValues={initialValues}>
            <p className={cx('title')}>{props?.title}</p>
            <Form.Item>
                <div className={cx('body_modal')}>
                    <p className={cx('title_price')}>Price range</p>
                    <p className={cx('price')}>Price</p>
                </div>

                <div>
                    <Row style={{ justifyContent: 'space-around' }}>
                        <Form.Item
                            name="priceLow"
                            rules={[
                                {
                                    validator: async (_, value) => {
                                        const valueHigh = form.getFieldValue('priceHigh');
                                        if (valueHigh > 0 && valueHigh <= Number(value)) {
                                            return setIsErr(true);
                                        } else {
                                            return setIsErr(false);
                                        }
                                    },
                                },
                            ]}
                        >
                            {/* <Input
                                placeholder="From"
                                className={cx('item_input')}
                                onKeyDown={checkKeyDownNumberInput}
                                // onChange={(e) => {
                                //     const valueHigh = form.getFieldValue('priceHigh');

                                //     if (valueHigh > 0 && valueHigh <= Number(e.target.value)) {
                                //         setIsErr(true);
                                //     } else {
                                //         setIsErr(false);
                                //     }
                                // }}
                            /> */}
                            <InputNumber
                                placeholder="From"
                                className={cx('item_input')}
                                onKeyDown={checkKeyDownNumberInput}
                                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                            />
                        </Form.Item>

                        <span style={{ fontSize: '25px' }}>-</span>
                        <Form.Item
                            name="priceHigh"
                            rules={[
                                {
                                    validator: async (_, value) => {
                                        const valueLow = form.getFieldValue('priceLow');
                                        if (valueLow > 0 && valueLow >= Number(value)) {
                                            return setIsErr(true);
                                        } else {
                                            return setIsErr(false);
                                        }
                                    },
                                },
                            ]}
                        >
                            {/* <Input
                                placeholder="Arrive"
                                className={cx('item_input')}
                                onKeyDown={checkKeyDownNumberInput}
                                // onChange={(e) => {
                                //     const valueLow = form.getFieldValue('priceLow');
                                //     if (valueLow > 0 && valueLow >= Number(e.target.value)) {
                                //         setIsErr(true);
                                //     } else {
                                //         setIsErr(false);
                                //     }
                                // }}
                            /> */}
                            <InputNumber
                                placeholder="Arrive"
                                className={cx('item_input')}
                                onKeyDown={checkKeyDownNumberInput}
                                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                            />
                        </Form.Item>
                    </Row>

                    {isErr && <p style={{ color: 'red', paddingLeft: '10px' }}>Price must be from low to high.</p>}
                    <Row style={{ justifyContent: 'space-around' }}>
                        <div
                            className={cx('value_price')}
                            onClick={() => {
                                handleSelectPrice(0, 100000);
                            }}
                        >
                            0-100K
                        </div>
                        <div
                            className={cx('value_price')}
                            onClick={() => {
                                handleSelectPrice(100000, 200000);
                            }}
                        >
                            100K-200K
                        </div>
                        <div
                            className={cx('value_price')}
                            onClick={() => {
                                handleSelectPrice(200000, 300000);
                            }}
                        >
                            200K-300K
                        </div>
                    </Row>
                </div>
            </Form.Item>

            <Form.Item style={{ marginTop: '40px', paddingBottom: '50px' }}>
                <Row>
                    <div
                        className={cx('btn_cancel')}
                        onClick={() => {
                            form.setFieldsValue({
                                priceLow: '',
                                priceHigh: '',
                            });
                        }}
                    >
                        Reset
                    </div>
                    <div className={cx('btn_logout')} onClick={handleSubmit}>
                        Apply
                    </div>
                </Row>
            </Form.Item>
        </Form>
    );
};

export default FormFilterPrice;
